module.exports = __webpack_public_path__ + "img/editor-img.2e045e40.jpeg";